<template>
  <div style="padding-top: 40px">
    <div>
      <div>
        <p class="navadno-besedilo">
          Ustvarite svoj imenik oseb. Tako bodo vaši kontakti vedno pri roki.
        </p>
      </div>
      <div style="padding-top: 30px">
        <p class="open-sans-20pt">
          Dodajte nov kontakt
        </p>
        <div style="padding-top: 30px">
          <div class="item1">
            <el-form label-width="160px" :label-position="formaOrientacija" class="nova-vrstica-forma">
              <el-form-item label="Ime" required>
                <el-input placeholder="Ime kontakta" v-model="dodajKontakt.ime" class="velikost-input">
                </el-input>
              </el-form-item>
              <el-form-item label="Priimek" required>
                <el-input placeholder="Priimek kontakta" v-model="dodajKontakt.priimek" class="velikost-input">
                </el-input>
              </el-form-item>
              <el-form-item label="Telefonska številka" required>
                <el-select class="list-zacetnih-st"
                           v-model="izbranaZacetnaStVDialogu = urediZacetnaStTelefona">
                  <el-option v-for="poz in listaZacetnihSt"
                             :key="poz"
                             :label="poz"
                             :value="poz">
                  </el-option>
                </el-select>
                <el-input v-model="dodajKontakt.mobile" class="velikost-input-telefonska-stevilka"
                          placeholder="Telefonska številka">
                </el-input>
              </el-form-item>
              <el-form-item label="Dodaj k skupini">
                <el-select multiple
                           class="velikost-input"
                           v-model="dodajKontakt.groups">
                  <el-option v-for="poz in vseSkupine.groups"
                             :key="poz.idGroup"
                             :label="poz.naziv"
                             :value="poz.idGroup">
                  </el-option>
                </el-select>
                <span class="dodaj-skupini">
                  <i class="levi-odmik-ikone">
                  <img src="/static/img/UporabniskiKoticek/UporabneStrani/Icon-awesome-info-circle.png"
                       class="Icon-awesome-info-circle open-sans-10pt">
                    <small class="open-sans-10pt">
                      V imeniku oseb lahko shranjene kontakte ločite v skupine.
                      Če želite, da je kontakt del skupine, jo izberite s seznama.
                      Če skupin še nimate, jih morate najprej ustvariti (zavihek Imenik skupin).
                    </small>
                  </i>
                </span>
              </el-form-item>
            </el-form>
          </div>
          <div style="padding-top: 40px" class="mobile-behavior">
            <el-button
              class="gumb-potrdi"
              @click="DodajanjeKontakta()">
              SHRANI KONTAKT
            </el-button>
            <b style="padding-left: 30px; padding-right: 30px">
              ALI
            </b>
              <div class="mobile-behavior">
                <file-reader
                  :key="fileReaderKey"
                  id="v-card"
                  accept=".xlsx,.xls,.vcf"
                  output="binary"
                  ref="reader"
                  @reader-load="PreberiDatoteko">
                </file-reader>
                <el-button
                  :disabled="branjeVTeku"
                  @click="NaloziDatoteko"
                  class="gumb-dodaj">
                  {{!branjeVTeku ? 'NALOŽI DATOTEKO ZA UVOZ' : 'V teku'}}
                </el-button>
                <span class="dodaj-skupini uvoz">
                    <i class="levi-odmik-ikone">
                    <img src="/static/img/UporabniskiKoticek/UporabneStrani/Icon-awesome-info-circle.png"
                           class="Icon-awesome-info-circle open-sans-10pt">
                      <small class="open-sans-10pt">
                        Uvoz - VCF (vCard) ali Excel datoteka
                      </small>
                    </i>
                </span>
            </div>
          </div>
          <div>
            <span class="dodaj-skupini opis">
              <i class="levi-odmik-ikone">
              <img src="/static/img/UporabniskiKoticek/UporabneStrani/Icon-awesome-info-circle.png"
                   class="Icon-awesome-info-circle open-sans-10pt">
                <small class="open-sans-10pt">
                  Za uspešen uvoz Excelove datoteke je pomemben pravilen vrstni red podatkov. Kot primer lahko izvozite
                  <a @click="PrenesiVzorcnoDatoteko" style="cursor: pointer" class="primarna-barva">
                    vzorčno datoteko</a>.
                </small>
              </i>
            </span>
          </div>
        </div>
      </div>
      <div style="padding-top: 40px">
        <hr class="hr-stil">
      </div>
      <div style="padding-top: 40px">
        <p class="open-sans-20pt">
          Seznam kontaktov
          <span class="iskanje-input">
            <el-input v-model="isciPoPodatkih" class="iskanje-kontaktov-input"
                      placeholder="Poišči kontakt" prefix-icon="el-icon-search">
            </el-input>
          </span>
        </p>
        <div v-if="seznamKontaktov.length > 0">
          <div style="padding-top: 20px; padding-bottom: 10px">
            <p class="navadno-besedilo">
              Označite kontakte, ki jih želite dodati med prejemnike sporočila.
            </p>
          </div>
          <div v-loading="nalaganjeKontaktovLoading">
            <el-table
              :data="seznamKontaktov"
              :expand-row-keys="expandRowKeys"
              :row-key="row => row.idAddressBook"
              @expand-change="ImenikKontaktov"
              style="width: 100%">
              <el-table-column
                min-width="25"
                label="Izberite">
                <template slot-scope="scope">
                  <input type="checkbox"
                         class="color-checkbox"
                         :disabled="izbraniKontakti.length >= smsLimit && !izbraniKontakti.includes(scope.row)"
                         :value=scope.row
                         v-model="izbraniKontakti"
                        @change="SelectContact(scope.row.idAddressBook)">
                </template>
              </el-table-column>
              <el-table-column
                min-width="35"
                prop="ime"
                label="Ime">
              </el-table-column>
              <el-table-column
                min-width="35"
                prop="priimek"
                label="Priimek">
              </el-table-column>
              <el-table-column
                prop="mobile"
                min-width="95"
                label="Telefonska številka">
              </el-table-column>
              <el-table-column
                label="" width="60px">
                <template slot-scope="scope">
                  <a @click="OdstraniKontaktIzImenika(scope.row.idAddressBook)" style="cursor: pointer">
                    <img src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png">
                  </a>
                </template>
              </el-table-column>
              <el-table-column type="expand">
                <template slot-scope="props">
                  <div class="notranji-odmik-kontakt urejanje-tabela">
                    <el-form label-width="160px" :label-position="formaOrientacija" :key="props.idAddressBook">
                      <el-form-item label="Ime">
                        <el-input placeholder="Ime kontakta" v-model="UrediKontaktSms.ime" class="velikost-input">
                        </el-input>
                      </el-form-item>
                      <el-form-item label="Priimek">
                        <el-input placeholder="Priimek kontakta" v-model="UrediKontaktSms.priimek"
                                  class="velikost-input">
                        </el-input>
                      </el-form-item>
                      <el-form-item label="Telefonska številka">
                        <el-select class="list-zacetnih-st" v-model="firstParthPhone">
                          <el-option v-for="poz in listaZacetnihSt"
                                     :key="poz"
                                     :label="poz"
                                     :value="poz">
                          </el-option>
                        </el-select>
                        <el-input v-model="lastParthPhone" class="velikost-input-telefonska-stevilka"
                                  placeholder="Telefonska številka">
                        </el-input>
                      </el-form-item>
                      <el-form-item label="Dodaj k skupini">
                        <el-select class="velikost-input"
                                   multiple
                                   v-model="UrediKontaktSms.groups">
                          <el-option v-for="poz in vseSkupine.groups"
                                     :key="poz.idGroup"
                                     :label="poz.naziv"
                                     :value="poz.idGroup">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                    <div style="padding-top: 30px">
                      <el-button class="gumb-potrdi" @click="UrejanjeKontakta()">
                        SHRANI SPREMEMBE
                      </el-button>
                      <a @click="InitContact()" class="stil-gumb-preklici">
                        Prekliči
                      </a>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="text-center" style="cursor: pointer;">
              <br/>
              <el-pagination
                :hide-on-single-page="true"
                @current-change="PrikaziStranKontaktov"
                :page-size="4"
                layout="prev, pager, next"
                :total="dolzinaSeznamaKontaktov"
                small>
              </el-pagination>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="obvestilo-kontaktov">
            Brez ustvarjenih kontaktov
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Select, Option, Table, Button, Input, Tooltip, Collapse, CollapseItem, Dialog, MessageBox,
  Form, FormItem, Pagination, Upload
} from 'element-ui'
import {SirinaOkna} from '../../../../../assets/js/globalne_funkcije/SirinaOkna'
import Validacija from '../../../../../assets/js/globalne_funkcije/Validacija'
import {ReadFile} from '../../../../../assets/js/globalne_funkcije/Kontakti/ReadFile'
import FileReader from 'vue-filereader'

export default {
  name: 'ImenikSkupin',
  mixins: [SirinaOkna, ReadFile],
  components: {
    [Button.name]: Button,
    [Select.name]: Select,
    [Table.name]: Table,
    [Option.name]: Option,
    [Input.name]: Input,
    [Tooltip.name]: Tooltip,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Pagination.name]: Pagination,
    [Upload.name]: Upload,
    [FileReader.name]: FileReader
  },
  data () {
    return {
      nalaganjeKontaktovLoading: false,
      isciPoPodatkih: '',
      izbraneSkupine: [],
      izbraniKontakti: [],
      activeName: '0',
      urediZacetnaStTelefona: '064',
      dodajKontakt: {},
      urediKontakt: {},
      UrediKontaktSms: {idKontakt: 0, ime: '', priimek: '', telefon: '', email: ''},
      skupineKontakta: [],
      formaOrientacija: 'left',
      expandRowKeys: [],
      mejnaSirina: 1400,
      copyVsiKontakti: [],
      dolzinaSeznamaKontaktov: null,
      firstParthPhone: '064',
      seznamKontaktov: [],
      lastParthPhone: '',
      title: 'Dodajanje kontakta',
      noviSeznamGroups: [],
      validacija: new Validacija(),
      najdenaStevilkaKontaktniSeznam: false,
      branjeVTeku: false,
      fileReaderKey: Date.now(),
      povezavaVzorcnaDatoteka: '../static/documents/Primer_podatkov.xlsx'
    }
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    this.izbraniKontakti = this.selectedContacts
    this.copyVsiKontakti = this.vsiKontakti
    if (typeof this.copyVsiKontakti !== 'undefined') {
      this.PreverjanjeKontaktov()
    }
    this.InitContact()
  },
  props: {
    listaZacetnihSt: null,
    izbranPosiljatelj: null,
    vsiKontakti: null,
    vseSkupine: null,
    selectedContacts: null,
    clientAgent: null,
    smsAuthentication: false,
    smsLimit: 0
  },
  watch: {
    vsiKontakti: function () {
      this.nalaganjeKontaktovLoading = false
      this.copyVsiKontakti = this.vsiKontakti
      if (typeof this.copyVsiKontakti !== 'undefined') {
        this.PreverjanjeKontaktov()
      }
      this.isciPoPodatkih = ''
    },
    isciPoPodatkih: function (val) {
      if (val.length > 0) {
        let podatek = this.vsiKontakti.filter(x =>
          x.ime.toLowerCase().includes(val.toLowerCase()) ||
          x.priimek.toLowerCase().includes(val.toLowerCase()) ||
          x.ime.concat(x.priimek).toLowerCase().includes(val.replace(/\W/g, '').toLowerCase()) ||
          x.mobile.toString().includes(val))
        this.seznamKontaktov = podatek
      } else {
        this.seznamKontaktov = this.vsiKontakti
      }
    },
    vseSkupine: function () {
      if (typeof this.izbraneSkupine.length !== 'undefined' && this.izbraneSkupine.length > 0 &&
        this.dodajKontakt.idKontakt === 0) {
        this.dodajKontakt.idKontakt = this.vsiKontakti[this.vsiKontakti.length - 1].idAddressBook
        this.AddContactGroups()
      } else {
        this.nalaganjeKontaktovLoading = false
      }
    }
  },
  methods: {
    NaloziDatoteko () {
      document.getElementsByClassName('file-reader__control')[0].click()
    },
    PrenesiVzorcnoDatoteko () {
      const url = '/static/documents/Primer_podatkov.xlsx'
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Primer_podatkov.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async PreberiDatoteko (file) {
      if (!file.file) return
      const extension = file.file.name.split('.').pop().toLowerCase()
      let contacts = []
      if (extension === 'vcf') {
        contacts = this.ReadVCFFile(file, this.vsiKontakti)
      } else if (extension === 'xlsx' || extension === 'xls') {
        contacts = await this.ReadExcelFile(file, this.vsiKontakti)
      } else {
        this.ShowWarningMessage({ message: 'Nepodprta datoteka. Izberi VCF ali XLS datoteko.' })
        return
      }
      if (contacts.length === 0) {
        this.ShowWarningMessage({ message: 'Ni novih kontaktov za uvoz.' })
        this.branjeVTeku = false
      } else if (contacts.length > 1000) {
        this.ShowWarningMessage({ message: 'Uvozite lahko največ 1000 kontaktov hkrati.' })
        this.branjeVTeku = false
      } else {
        this.branjeVTeku = true
        await this.ShraniNaborKontaktov(contacts, true, contacts.length)
      }
      this.fileReaderKey = Date.now()
    },
    PreverjanjeKontaktov () {
      let tmpArray = []
      this.dolzinaSeznamaKontaktov = this.copyVsiKontakti.length
      const chunk = 4
      for (let i = 0; i < this.dolzinaSeznamaKontaktov; i += chunk) {
        tmpArray.push(this.copyVsiKontakti.slice(i, i + chunk))
      }
      this.copyVsiKontakti = tmpArray
      this.PrikaziStranKontaktov(1)
    },
    PrikaziStranKontaktov (stran) {
      if (typeof this.copyVsiKontakti[stran - 1] !== 'undefined') {
        this.seznamKontaktov = this.copyVsiKontakti[stran - 1]
      } else {
        this.seznamKontaktov = []
      }
    },
    ImenikKontaktov (row, expandedRows) {
      const id = row.idAddressBook
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
      if (expandedRows.length !== 0) {
        this.UrediKontaktSms = row
        this.firstParthPhone = this.UrediKontaktSms.mobile.slice(0, 3)
        this.lastParthPhone = this.UrediKontaktSms.mobile.slice(3, 9)
      }
    },
    InitContact () {
      this.izbraniKontakti = []
      this.izbraneSkupine = []
      this.skupineKontakta = []
      this.title = 'Dodajanje kontakta'
      this.dodajKontakt = {idKontakt: 0, ime: '', priimek: '', telefon: '', email: '', groups: []}
      this.UrediKontaktSms = {idKontakt: 0, ime: '', priimek: '', telefon: '', email: '', groups: []}
      this.activeName = '0'
    },
    SelectContact (idAddressBook) {
      if (this.izbraniKontakti.length > 0 && !this.smsAuthentication) {
        let checkboxes = document.getElementsByClassName('color-checkbox')
        for (var i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = false
        }
        this.$emit('mfaIzklopljen')
      } else {
        if (this.noviSeznamGroups.includes(idAddressBook)) {
          for (let i = 0; i < this.noviSeznamGroups.length; i++) {
            if (this.noviSeznamGroups[i] === idAddressBook) {
              this.noviSeznamGroups.splice(i, 1)
            }
          }
        } else {
          this.noviSeznamGroups.push(idAddressBook)
          if (this.izbraniKontakti.length < this.smsLimit) {
            let paramObvestilo = {}
            this.$emit('updateSelectedContacts', this.izbraniKontakti)
            paramObvestilo.message = 'Kontakt dodan med prejemnike.'
            this.ShowSuccessMessage(paramObvestilo)
          } else if (this.izbraniKontakti.length === this.smsLimit) {
            let paramObvestilo = {}
            this.$emit('updateSelectedContacts', this.izbraniKontakti)
            paramObvestilo.message = 'Dosegli ste maksimalno število kontaktov.'
            this.ShowSuccessMessage(paramObvestilo)
          } else if (this.izbraniKontakti.length > this.smsLimit) {
            this.izbraniKontakti.splice(-1)
            let paramObvestilo = {}
            paramObvestilo.message = 'Izbranih je lahko največ ' + this.smsLimit + ' prejemnikov.'
            this.ShowErrorMessage(paramObvestilo)
          } else {
            this.izbraniKontakti.splice(-1)
          }
        }
      }
    },
    OdstraniKontaktIzImenika (contactId) {
      MessageBox.confirm('Ali ste prepričani, da želite odstraniti kontakt?', {
        confirmButtonText: 'Da',
        cancelButtonText: 'Prekliči',
        confirmButtonClass: 'gumb-potrdi',
        cancelButtonClass: 'gumb-preklici',
        customClass: 'opozorilo-dialog'
      }).then(() => {
        this.IzbrisiKontakt(contactId)
      }).catch(() => {

      })
    },
    IzbrisiKontakt (contactId) {
      let param = ['posiljatelj=' + this.izbranPosiljatelj.telefonska_stevilka]
      param.push(['idKontakt=' + contactId])
      let errorMessage = 'Napaka pri odstranjevanju kontakta.'
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/sms/imenik/izbrisiKontakt?',
        param,
        errorMessage,
        'SendDeleteContact',
        'SendErrorMsg')
    },
    UrediKontakt (contact) {
      this.InitContact()
      this.activeName = '1'
      this.title = 'Urejanje kontakta'
      if (typeof this.vsiKontakti.length !== 'undefined') {
        for (let i = 0; i < this.vsiKontakti.length; i++) {
          if (this.vsiKontakti[i].idAddressBook === contact.idAddressBook) {
            this.UrediKontaktSms = JSON.parse(JSON.stringify(this.vsiKontakti[i]))
            this.urediZacetnaStTelefona = this.vsiKontakti[i].mobile.substr(0, 3)
            this.UrediKontaktSms.mobile = this.vsiKontakti[i].mobile.slice(3, 9)
            this.UrediKontaktSms.idKontakt = this.vsiKontakti[i].idAddressBook
            break
          }
        }
      }
      if (this.UrediKontaktSms.idKontakt === 0) {
        this.SendErrorMsg('Napaka pri pridobivanju podatkov kontakta.')
        return false
      }
      this.skupineKontakta = []
      if (typeof this.vseSkupine.groups.length !== 'undefined') {
        for (let j = 0; j < this.vseSkupine.groups.length; j++) {
          for (let k = 0; k < this.vseSkupine.groups[j].contacts.length; k++) {
            if (this.vseSkupine.groups[j].contacts[k].idAddressBook === this.UrediKontaktSms.idAddressBook) {
              this.skupineKontakta.push(JSON.parse(JSON.stringify(this.vseSkupine.groups[j])))
              this.izbraneSkupine.push(this.vseSkupine.groups[j].idGroup)
              break
            }
          }
        }
      }
    },
    DodajanjeKontakta () {
      const mobile = this.izbranaZacetnaStVDialogu + this.dodajKontakt.mobile
      const ime = this.dodajKontakt.ime
      const priimek = this.dodajKontakt.priimek
      for (const element of this.vsiKontakti) {
        if (element.mobile === mobile && element.ime === ime && element.priimek === priimek) {
          this.ShowWarningMessage({ message: 'Kontakt s temi podatki že obstaja.' })
          this.InitContact()
          return
        }
        if (element.mobile === mobile) {
          this.ShowWarningMessage({ message: 'Telefonska številka že obstaja v seznamu kontaktov.' })
          this.InitContact()
          return
        }
      }
      if ((!ime || !priimek) && (!this.dodajKontakt.mobile)) {
        this.ShowWarningMessage({ message: 'Prosimo, vnesite vse zahtevane podatke.' })
        return
      }
      if (!/^\d{9}$/.test(mobile) || !this.validacija.TelefonskaStevilkaValidation(mobile)) {
        this.ShowWarningMessage({ message: 'Napačen zapis telefonske številke. Prosimo, preverite.' })
        return
      }
      this.ShraniNaborKontaktov([{
        ime,
        priimek,
        email: this.dodajKontakt.email,
        idKontakt: 0,
        telefon: mobile,
        group: [...this.dodajKontakt.groups]
      }])
    },
    async ShraniNaborKontaktov (naborKontaktov = [], masovniUvoz = false, novihKontaktov = 0) {
      if (naborKontaktov.length !== 0) {
        try {
          await this.clientAgent.makeRequest(
            'prikljucek/sms/imenik/shraniKontakt?',
            {
              newContacts: JSON.stringify(naborKontaktov),
              posiljatelj: this.izbranPosiljatelj.telefonska_stevilka
            },
            'POST'
          )
          this.SendAddedContact(masovniUvoz, novihKontaktov)
        } catch (e) {
          this.SendErrorMsg(e)
        }
      }
      this.branjeVTeku = false
    },
    async UrejanjeKontakta () {
      let kontakt = {}
      kontakt['posiljatelj='] = this.izbranPosiljatelj.telefonska_stevilka
      this.UrediKontaktSms.mobile = this.firstParthPhone + this.lastParthPhone
      kontakt['ime'] = this.UrediKontaktSms.ime
      kontakt['priimek'] = this.UrediKontaktSms.priimek
      kontakt['telefon'] = this.UrediKontaktSms.mobile
      kontakt['email'] = this.UrediKontaktSms.email
      kontakt['idKontakt'] = this.UrediKontaktSms.idAddressBook
      let groups = []
      for (let i = 0; i < this.UrediKontaktSms.groups.length; i++) {
        groups.push(this.UrediKontaktSms.groups[i])
      }
      kontakt['group'] = groups
      let naborKontaktov = [kontakt]

      let errorMessage = 'Napaka pri urejanju kontakta.'
      await this.clientAgent.makeRequest(
        'prikljucek/sms/imenik/shraniKontakt?',
        {
          newContacts: JSON.stringify(naborKontaktov),
          posiljatelj: this.izbranPosiljatelj.telefonska_stevilka
        },
        'POST'
      ).catch((e) => this.SendErrorMsg(errorMessage))
      this.SendAddedContact()
      this.firstParthPhone = '064'
      this.lastParthPhone = ''
      this.expandRowKeys = []
    },
    UpdateContactsAndGroups () {
      this.$emit('updateKontakt')
      this.$emit('updateGroups')
    },
    SendUpdateContact () {
      this.nalaganjeKontaktovLoading = true
      let paramObvestilo = {}
      paramObvestilo.message = 'Kontakt je bil uspešno posodobljen.'
      this.ShowSuccessMessage(paramObvestilo)
      this.InitContact()
      this.UpdateContactsAndGroups()
    },
    SendDeleteContact () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno odstranjen kontakt.'
      this.ShowSuccessMessage(paramObvestilo)
      this.InitContact()
      this.UpdateContactsAndGroups()
    },
    SendAddedContact (masovniUvoz = false, novihKontaktov = 0) {
      this.nalaganjeKontaktovLoading = true
      let paramObvestilo = {}
      paramObvestilo.message = masovniUvoz ? `Uspešno uvoženih ${novihKontaktov} kontaktov.` : `Uspešno dodan kontakt.`
      this.ShowSuccessMessage(paramObvestilo)
      this.InitContact()
      this.UpdateContactsAndGroups()
    },
    SendErrorMsg (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/UporabniskiKoticek/PosljiSms/ImenikKontaktov.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/UporabniskiKoticek/PosljiSms/ImenikOseb.vue